import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  getLunchAmounts,
  getMassageAmounts,
  getRecreationalAmounts,
  getTransportAmounts,
  getWellbeingAmounts
} from '@epi-selectors/settings';
import { IBenfitTypeWithMaxAmount } from '@epi-models/containers/ManageBenefitGroups';

export const useGetAmounts = () => {
  const { benefitGroup } = useParams<{ benefitGroup: string }>();

  const selectors = {
    lunch: getLunchAmounts,
    recreational: getRecreationalAmounts,
    massage: getMassageAmounts,
    wellbeing: getWellbeingAmounts,
    transport: getTransportAmounts
  };

  return useSelector(selectors[benefitGroup] ?? (() => [])) as number[];
};

export const useBenefitAmounts = (): IBenfitTypeWithMaxAmount => {
  return {
    Lunch: useSelector(getLunchAmounts),
    Recreational: useSelector(getRecreationalAmounts),
    Massage: useSelector(getMassageAmounts),
    Wellbeing: useSelector(getWellbeingAmounts),
    Transport: useSelector(getTransportAmounts)
  };
};
